export default function(ctx) {
var __t, __p = '';
__p += '<div data-container></div>';
return __p
}